import {combineReducers} from 'redux';
import search from './search';
import simpleSearchResults from './simpleSearchResults';
import language from './language';
import font from './font';
import contrast from './contrast';
import currentResult from './currentResult.js';
import advancedSearch from './advancedSearch.js';
import characteristics from './characteristics.js';
import mainPage from './mainPage.js';
import aboutPbl from './aboutPbl.js';
import news from './news.js';
import newsItem from './newsItem.js';
import collectionsAbout from './collectionsAbout.js';
import collections from './collections.js';
import headingDetails from './headingDetails.js';
import apiData from './apiData.js';
import authentication from './authentication.js';
import alert from './alert.js';
import {reducer as formReducer} from 'redux-form';

export default combineReducers({
    search,
    simpleSearchResults,
    currentResult,
    advancedSearch,
    characteristics,
    language,
    apiData,
    font,
    contrast,
    mainPage,
    aboutPbl,
    news,
    newsItem,
    collectionsAbout,
    collections,
    headingDetails,
    authentication,
    alert,
    form: formReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js